import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth';

const Index = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    console.log('Index page loaded, checking auth state...', { user, isLoading });
    
    try {
      // Add a small delay to ensure auth state is properly loaded
      const timer = setTimeout(() => {
        // Don't redirect while still loading auth state
        if (isLoading) {
          console.log('Auth state is still loading, waiting...');
          return;
        }
        
        // If user is already logged in, go to dashboard
        if (user) {
          console.log('User is logged in, redirecting to dashboard');
          navigate('/dashboard');
        } else {
          // Otherwise go to auth page
          console.log('No user logged in, redirecting to auth page');
          navigate('/auth');
        }
      }, 300); // Increased delay to ensure auth state is ready
      
      return () => clearTimeout(timer);
    } catch (err) {
      console.error('Error in Index page:', err);
      setError('Something went wrong while checking authentication. Please refresh the page.');
    }
  }, [navigate, user, isLoading]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center p-6 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
          <h2 className="text-xl font-bold text-red-600 dark:text-red-400 mb-4">Application Error</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Refresh Page
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="mb-4 animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
        <p className="text-gray-600 dark:text-gray-300">Loading application...</p>
      </div>
    </div>
  );
};

export default Index;
